// Media upload constants for MAX Aspire platform

// Supported media types
export type MediaType = "image" | "video" | "pdf" | "gif" | "document";

// Supported media types array
export const SUPPORTED_MEDIA_TYPES: MediaType[] = ["image", "video", "pdf", "gif", "document"];

// Maximum file sizes per media type (in bytes)
export const MAX_FILE_SIZES = {
    image: 10 * 1024 * 1024, // 10MB for images
    video: 100 * 1024 * 1024, // 100MB for videos
    pdf: 25 * 1024 * 1024, // 25MB for PDFs
    gif: 15 * 1024 * 1024, // 15MB for GIFs
    document: 10 * 1024 * 1024, // 10MB for documents
} as const;

// MIME type mappings for validation
export const MIME_TYPE_MAPPINGS = {
    image: ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/bmp", "image/tiff"],
    video: [
        "video/mp4",
        "video/avi",
        "video/mov",
        "video/wmv",
        "video/flv",
        "video/webm",
        "video/mkv",
    ],
    pdf: ["application/pdf"],
    gif: ["image/gif"],
    document: [
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
        "text/plain",
        "application/rtf",
    ],
} as const;

// File extensions mapping
export const FILE_EXTENSIONS = {
    image: [".jpg", ".jpeg", ".png", ".webp", ".bmp", ".tiff"],
    video: [".mp4", ".avi", ".mov", ".wmv", ".flv", ".webm", ".mkv"],
    pdf: [".pdf"],
    gif: [".gif"],
    document: [".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".txt", ".rtf"],
} as const;

// Maximum number of media items per post
export const MAX_POST_MEDIA = 10;

// Media upload limits per type (for UI display)
export const MEDIA_UPLOAD_LIMITS = {
    image: { max: 5, description: "Up to 5 images" },
    video: { max: 2, description: "Up to 2 videos" },
    pdf: { max: 3, description: "Up to 3 PDFs" },
    gif: { max: 3, description: "Up to 3 GIFs" },
    document: { max: 3, description: "Up to 3 documents" },
} as const;

// Media icons mapping for UI
export const MEDIA_ICONS = {
    image: "PhotoOutlined",
    video: "VideoCallOutlined",
    pdf: "PictureAsPdfOutlined",
    gif: "GifOutlined",
    document: "AttachFileOutlined",
} as const;

// Default thumbnail URLs for different media types
export const DEFAULT_THUMBNAILS = {
    pdf: "/assets/icons/pdf-thumbnail.png",
    document: "/assets/icons/document-thumbnail.png",
    video: "/assets/icons/video-thumbnail.png",
} as const;
